import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import aboutus from '@/views/aboutus/aboutus'  //指向folder下的.vue文件
import relation from '@/views/relation/relation'
import ability from '@/views/ability/ability'
import rescueListPage from '@/views/rescueList/rescueList'
import rescuedetail from '@/views/rescueList/rescuedetail'
import aboutTheSavior from '@/views/aboutTheSavior/aboutTheSavior'
import globalRescue from '@/views/globalRescue/globalRescue'
import healthMonitoring from '@/views/healthMonitoring/healthMonitoring'
import firstAidKit from '@/views/firstAidKit/firstAidKit'
import companyIntro from '@/views/companyIntro/companyIntro'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    {
      path: '/rescuelist',
      name: 'rescuelist',
      component: rescueListPage,
      meta: { hideLayout: true, atsPage: 'rescueList', atsNavId: 'list' }
    },
    {
      path: '/relation',
      name: 'relation',
      component: relation
    },
    {
      path: '/ability',
      name: 'ability',
      component: ability
    },
    {
      path: '/rescuedetail',
      name: 'rescuedetail',
      component: rescuedetail
    },
    {
      path: '/about-the-savior',
      name: 'aboutTheSavior',
      component: aboutTheSavior,
      meta: { hideLayout: true, atsPage: 'savior', atsNavId: 'about' }
    },
    {
      path: '/global-rescue',
      name: 'globalRescue',
      component: globalRescue,
      meta: { hideLayout: true, atsPage: 'globalRescue', atsNavId: 'global' }
    },
    {
      path: '/rescue-list',
      name: 'rescueListPage',
      component: rescueListPage,
      meta: { hideLayout: true, atsPage: 'rescueList', atsNavId: 'list' }
    },
    {
      path: '/health-monitoring',
      name: 'healthMonitoring',
      component: healthMonitoring,
      meta: { hideLayout: true, atsPage: 'healthMonitoring', atsNavId: 'health' }
    },
    {
      path: '/first-aid-kit',
      name: 'firstAidKit',
      component: firstAidKit,
      meta: { hideLayout: true, atsPage: 'firstAidKit', atsNavId: 'aid' }
    },
    {
      path: '/company-intro',
      name: 'companyIntro',
      component: companyIntro,
      meta: { hideLayout: true, atsPage: 'companyIntro', atsNavId: 'company' }
    }
  ],
  scrollBehavior(to, from, saveTop){
    if (saveTop) {
      return saveTop;
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js